// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // :sm="6" :md="4" :lg="3" :xl="1"]

export default [
	{ label:'业务日期：',xs:24,sm:24,md:6,lg:6,xl:6,type:'date',modelValue:'busDate',disabled:true},
	{ label:'申请科室：',xs:24,sm:24,md:6,lg:6,xl:6,type:'select',modelValue:'putInDep',op:'selectOption'},
	{ label:'申请人：',xs:24,sm:24,md:6,lg:6,xl:6,type:'select',modelValue:'applicantId',op:'ssrOption'},
	{ label:'供货单位：',xs:24,sm:24,md:6,lg:6,xl:6,type:'select',modelValue:'supplyCandidateId',placeholder:'',op:'gysOption'},
	
	{ label:'备注：',xs:24,sm:24,md:24,lg:24,xl:24,type:'textarea',modelValue:'remarks'},
	
	// { label:'药品名称：',xs:6,sm:6,md:6,lg:6,xl:6,type:'select',modelValue:'drugName',im:false,placeholder:'',op:'nameOption'},
	// { label:'规格描述：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'drugSpecifications',im:false,placeholder:'',op:'selectOption'},
	// { label:'生产厂家：',xs:6,sm:6,md:6,lg:6,xl:6,type:'select',modelValue:'manufacturerName',placeholder:'',disabled:true},
	// { label:'合同数量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'cd',placeholder:'',disabled:true},
	
	// { label:'上月销量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'ph',disabled:true},
	// { label:'上月采购数量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'wh',disabled:true},
	// { label:'同期采购数量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'cbdj',disabled:true},
	// { label:'已购数量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'xdwcbdj',disabled:true},
	
	// { label:'单价（盒）：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'purcPric',placeholder:''},
	// { label:'数量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'purCnt',placeholder:''},
	// { label:'备注：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'numZ',placeholder:'',},
	// { label:'近期销量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'cbje',disabled:true},
	
	// { label:'加入',xs:24,sm:24,md:24,lg:24,xl:24,type:'btn',modelValue:'educationalBackground',placeholder:'',},
]

